import Head from "next/head";
import { CommonData } from "../../types/CommonData";

import Header from "../../components/Header";
import { NextPage } from "next";
import { getCommonData } from "../../helpers/common-data";
import { getAnnouncements } from "../../helpers/getAnnouncements";
import { Announcement } from "../../types/Announcement";
import { Spacing, Column } from "../../helpers/layout";
import { Wrapper } from "../../components/Wrapper";
import { css } from "styled-components";
import { useUserState } from "../../context/UserContext";
import { Title } from "../../typography";
import { ResetPasswordForm } from "../../forms/ResetPasswordForm";
import { AlreadyAuthenticated } from "../../components/AlreadyAuthenticated";
import Footer from "../../components/Footer";

export const PageResetPassword: NextPage<{
  commonData: CommonData;
  announcements: Announcement[];
}> = props => {
  const { isAuthenticated } = useUserState();

  return (
    <>
      <Head>
        <title>Reset Password</title>
      </Head>
      <Header announcements={props.announcements} />
      <div
        css={css`
          margin-top: ${Spacing.xxl};
          text-align: center;
        `}
      >
        <Wrapper>
          {!isAuthenticated ? (
            <div
              css={css`
                max-width: 600px;
                margin: 0 auto;
              `}
            >
              <Column align="center">
                <Title>Reset Password</Title>
                <div>
                  <p>
                    Please enter your email address. You will receive a link to
                    create a new password via email.
                  </p>
                </div>
                <div
                  css={css`
                    padding: ${Spacing.xl} 0 ${Spacing.xxl};
                    box-sizing: border-box;
                  `}
                >
                  <ResetPasswordForm />
                </div>
              </Column>
            </div>
          ) : (
            <div
              css={css`
                margin-bottom: ${Spacing.xxl};
              `}
            >
              <AlreadyAuthenticated />
            </div>
          )}
        </Wrapper>
        <Footer />
      </div>
    </>
  );
};

PageResetPassword.getInitialProps = async ({ req }) => {
  const commonData = await getCommonData(req);
  const announcements = await getAnnouncements("ALL");
  return {
    commonData: commonData,
    announcements
  };
};
export default PageResetPassword;
